import { render, staticRenderFns } from "./createTicketForm.vue?vue&type=template&id=3b743d82&scoped=true&"
import script from "./createTicketForm.vue?vue&type=script&lang=js&"
export * from "./createTicketForm.vue?vue&type=script&lang=js&"
import style0 from "./createTicketForm.vue?vue&type=style&index=0&id=3b743d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b743d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VForm,VTextField,VTextarea})
